import { GenericTableRow } from "../../../types"

export const formatData = (data: any, key: string) => {
  return { key: key, value: data[key as keyof GenericTableRow["type"]] }
}

export const formatTitle = (
  title:
    | string
    | {
        text: string
        dataLength: number
      },
) => {
  const splitter =
    typeof title === "string" ? title.split("vs.") : title.text.split("vs")
  return { firstRow: splitter[0], secondRow: splitter[1] }
}

export const getGCFOibiaXaxis = (key: string) => {
  switch (key) {
    case "targetVSYearToDateOiDelta":
      return "targetVSYearToDateRevenueDelta"

    case "yearToDateVSPreviousOiDelta":
      return "yearToDateVSPreviousRevenueDelta"

    default:
      return "previousVSActualRevenueDelta"
  }
}

export const getNonGCFOibiaXaxis = (key: string) => {
  switch (key) {
    case "budVSCurrOibiaVar":
      return "budVSCurrRevVarPerc"

    case "currVSPrevOibiaVar":
      return "currVSPrevRevVarPerc"

    default:
      return "currVSPrevActRevVarPerc"
  }
}

export const getYscale = (
  showRevenue: boolean,
  showOi: boolean,
  maxRevenue: number,
  maxOi: number,
  minRevenue: number,
  minOi: number,
  hasEntities: boolean,
) => {
  if (!hasEntities) {
    return [0, 0]
  }
  if (showOi && showRevenue) {
    return [
      maxRevenue > maxOi ? maxRevenue : maxOi,
      minRevenue < minOi ? minRevenue : minOi,
    ]
  }
  if (!showRevenue) {
    return [maxOi, minOi]
  }

  return [maxRevenue, minRevenue]
}
